import React, { FC, ReactNode } from 'react'
import { Box, DialogTitle, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { Typography } from '@mui/material'
import { MetaText } from './MetaText'

// モーダル共通 header. Notion 流 dense (= title 13/500/primary + ✕ close icon).
// border-bottom で content と区切る. subtitle 任意 (= MetaText で表示).
// action= close の左に並べる任意スロット (= ヘッダー右上のコピー等の ghost icon). 本文の
// 全体コピーを Notion 流「ヘッダー右上」に置く正典 (SOAP/報告書と同じ) を dialog でも使う。
// 5+ dialog で SSoT 化: SoapEditHistoryDialog / SoapUpdateChat / BulkReplaceDialog /
// MedicationPlaceholderText / KasanHistoryModal / 調剤鑑査 / 疑義照会 / 患者リンク共有.
interface DialogHeaderProps {
  title: ReactNode
  subtitle?: ReactNode
  action?: ReactNode
  onClose: () => void
  disabled?: boolean
}

export const DialogHeader: FC<DialogHeaderProps> = ({
  title,
  subtitle,
  action,
  onClose,
  disabled,
}) => (
  <DialogTitle
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: subtitle ? 'flex-start' : 'center',
      px: 3,
      py: 2,
      borderBottom: '1px solid rgba(55,53,47,0.09)',
    }}
  >
    <Box>
      <Typography sx={{ fontSize: 13, fontWeight: 500, color: 'text.primary' }}>
        {title}
      </Typography>
      {subtitle && <MetaText sx={{ mt: 0.25 }}>{subtitle}</MetaText>}
    </Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      {action}
      <IconButton size="small" onClick={onClose} disabled={disabled}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  </DialogTitle>
)
